import { render, staticRenderFns } from "./GoodsSelectForm.vue?vue&type=template&id=8a38cc08"
import script from "./GoodsSelectForm.vue?vue&type=script&lang=js"
export * from "./GoodsSelectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports